module.exports = __webpack_public_path__ + "img/search-icon.553aeb2b.svg";